'use strict';

/**
 * @classname InputRadioFavoriteShop
 * @classdesc お気に入り店舗選択
 */
export default class InputRadioFavoriteShop {
	/**
	 * @constructor
	 * @param {jQuery} $e - .input-radio--favorite-shop
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		$e.on('click', () => {
			$e.closest('.tab__content__pane').find('.btn--primary').prop('disabled', false);
		})
	};
};
